<script>
import { formatDateTimeBR } from '@/utils/energia/dates'

export default {
  props: {
    logs: { type: Array, default: () => [] },
  },
  methods: {
    formatLogData(data) {
      return formatDateTimeBR(data) || '—'
    },
    iconePorTipo(tipo) {
      const map = {
        ok:   'bx bx-check-circle text-success',
        warn: 'bx bx-error text-warning',
        err:  'bx bx-x-circle text-danger',
      }
      return map[tipo] || 'bx bx-circle text-muted'
    },
  },
}
</script>

<template>
  <div>
    <div v-if="!logs.length" class="text-muted font-size-13">
      Nenhum registro de atividade.
    </div>

    <div
      v-for="(log, i) in logs"
      :key="i"
      class="d-flex"
      style="position: relative; padding-bottom: 16px;"
    >
      <!-- Linha vertical conectando os itens -->
      <div
        v-if="i < logs.length - 1"
        style="position: absolute; left: 10px; top: 22px; bottom: 0; width: 2px; background: #d1d1e3;"
      ></div>

      <!-- Ícone do ponto -->
      <div class="mr-3" style="flex-shrink: 0; position: relative; z-index: 1;">
        <i :class="iconePorTipo(log.tipo)" class="font-size-20"></i>
      </div>

      <!-- Conteúdo -->
      <div>
        <p class="mb-0 font-size-11 text-muted">{{ formatLogData(log.data) }}</p>
        <p class="mb-0 font-size-13">{{ log.texto }}</p>
      </div>
    </div>
  </div>
</template>
